import { IntlShape } from 'react-intl'

import { PdfTypeEnum } from '../../../lib/graphql'

const labels = (intl: IntlShape): { [key: string]: string } => ({
  // USER PDFs
  [PdfTypeEnum.USER_QUOTATION]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.userQuotation',
    defaultMessage: 'Devis client',
  }),
  [PdfTypeEnum.USER_QUOTATION_ACTUALIZED]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.userQuotationActualized',
    defaultMessage: 'Devis client actualisé',
  }),
  [PdfTypeEnum.USER_QUOTATION_SIGNED]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.userQuotationSigned',
    defaultMessage: 'Devis client signé',
  }),
  [PdfTypeEnum.USER_QUOTATION_ACTUALIZED_SIGNED]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.userQuotationActualizedSigned',
    defaultMessage: 'Devis client actualisé signé',
  }),
  [PdfTypeEnum.USER_QUOTATION_ADJUSTED]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.userQuotationAdjusted',
    defaultMessage: 'Devis client ajusté',
  }),
  [PdfTypeEnum.USER_QUOTATION_ADJUSTED_SIGNED]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.userQuotationAdjustedSigned',
    defaultMessage: 'Devis client ajusté signé',
  }),
  [PdfTypeEnum.USER_BUSINESS_TRIP_CONDITIONS_UNSIGNED]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.userBusinessTripConditionsUnsigned',
    defaultMessage: 'Convention de voyage d’affaires',
  }),
  [PdfTypeEnum.USER_BUSINESS_TRIP_CONDITIONS_SIGNED]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.userBusinessTripConditionsSigned',
    defaultMessage: 'Convention de voyage d’affaires signée',
  }),
  [PdfTypeEnum.USER_BILLING]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.userBilling',
    defaultMessage: 'Facture client à la réservation',
  }),
  [PdfTypeEnum.USER_BILLING_BEFORE_30_DAYS]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.userBillingBefore30Days',
    defaultMessage: 'Facture client J-30',
  }),
  [PdfTypeEnum.USER_BILLING_POST_BOOKING]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.userBillingPostBooking',
    defaultMessage: 'Facture client après séjour',
  }),
  // OWNER PDFs
  [PdfTypeEnum.OWNER_QUOTATION_UNSIGNED]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.ownerQuotationUnsigned',
    defaultMessage: 'Devis',
  }),
  [PdfTypeEnum.OWNER_QUOTATION_SIGNED]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.ownerQuotationSigned',
    defaultMessage: 'Devis signé',
  }),
  [PdfTypeEnum.OWNER_QUOTATION_ACTUALIZED]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.ownerQuotationActualized',
    defaultMessage: 'Devis actualisé',
  }),
  [PdfTypeEnum.OWNER_QUOTATION_ACTUALIZED_SIGNED]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.ownerQuotationActualizedSigned',
    defaultMessage: 'Devis actualisé signé',
  }),
  [PdfTypeEnum.OWNER_QUOTATION_ADJUSTED]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.ownerQuotationAdjusted',
    defaultMessage: 'Devis ajusté',
  }),
  [PdfTypeEnum.OWNER_QUOTATION_ADJUSTED_VALIDATED]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.ownerQuotationAdjustedValidated',
    defaultMessage: 'Devis ajusté validé',
  }),
  [PdfTypeEnum.OWNER_MANDATE_CONTRACT_UNSIGNED]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.ownerMandateContractUnsigned',
    defaultMessage: 'Contrat de mandat',
  }),
  [PdfTypeEnum.OWNER_MANDATE_CONTRACT_SIGNED]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.ownerMandateContractSigned',
    defaultMessage: 'Contrat de mandat signé',
  }),
  [PdfTypeEnum.OWNER_BILLING]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.ownerBilling',
    defaultMessage: 'Facture à la réservation',
  }),
  [PdfTypeEnum.OWNER_BILLING_BEFORE_30_DAYS]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.ownerBillingBefore30Days',
    defaultMessage: 'Facture J-30',
  }),
  [PdfTypeEnum.OWNER_BILLING_POST_BOOKING]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.ownerBillingPostBooking',
    defaultMessage: 'Facture après séjour',
  }),
  [PdfTypeEnum.OWNER_COMMISSION_BILLING]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.ownerCommissionBilling',
    defaultMessage: 'Facture de commission à la réservation',
  }),
  [PdfTypeEnum.OWNER_COMMISSION_BILLING_BEFORE_30_DAYS]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.ownerCommissionBillingBefore30Days',
    defaultMessage: 'Facture de commission J-30',
  }),
  [PdfTypeEnum.OWNER_COMMISSION_BILLING_POST_BOOKING]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.ownerCommissionBillingPostBooking',
    defaultMessage: 'Facture de commission après séjour',
  }),
  [PdfTypeEnum.OWNER_RECEIPT]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.ownerReceipt',
    defaultMessage: 'Reçu à la réservation',
  }),
  [PdfTypeEnum.OWNER_RECEIPT_BEFORE_30_DAYS]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.ownerReceiptBefore30Days',
    defaultMessage: 'Reçu J-30',
  }),
  [PdfTypeEnum.OWNER_SPECIAL_CONDITIONS]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.ownerSpecialConditions',
    defaultMessage: "CGV de l'hôte",
  }),
  [PdfTypeEnum.OWNER_RECEIPT_POST_BOOKING]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.ownerReceiptPostBooking',
    defaultMessage: 'Reçu après séjour',
  }),
  // SERVICE OWNER PDFs
  [PdfTypeEnum.SERVICE_OWNER_QUOTATION_UNSIGNED]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.serviceOwnerQuotationUnsigned',
    defaultMessage: 'Devis de prestation',
  }),
  [PdfTypeEnum.SERVICE_OWNER_QUOTATION_ADJUSTED]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.serviceOwnerQuotationAdjusted',
    defaultMessage: 'Devis de prestation ajusté',
  }),
  [PdfTypeEnum.SERVICE_OWNER_RECEIPT_BEFORE_30_DAYS]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.serviceOwnerReceiptBefore30Days',
    defaultMessage: 'Reçu J-30',
  }),
  [PdfTypeEnum.SERVICE_OWNER_RECEIPT_POST_BOOKING]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.serviceOwnerReceiptPostBooking',
    defaultMessage: 'Reçu après séjour',
  }),
  [PdfTypeEnum.SERVICE_OWNER_BILLING_BEFORE_30_DAYS]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.serviceOwnerBillingBefore30Days',
    defaultMessage: 'Facture J-30',
  }),
  [PdfTypeEnum.SERVICE_OWNER_BILLING_POST_BOOKING]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.ownerBillingPostBooking',
    defaultMessage: 'Facture après séjour',
  }),
  [PdfTypeEnum.SERVICE_OWNER_BILLING_TO_BE_ESTABLISHED]: intl.formatMessage({
    id: 'ui.getPdfLabelsByTypes.serviceOwnerBillingToBeEstablished',
    defaultMessage: 'Facture à établir',
  }),
  [PdfTypeEnum.SERVICE_OWNER_BILLING_TO_BE_ESTABLISHED_CANCELED]:
    intl.formatMessage({
      id: 'ui.getPdfLabelsByTypes.serviceOwnerBillingToBeEstablishedCanceled',
      defaultMessage: 'Facture à établir annulée',
    }),
  [PdfTypeEnum.SERVICE_OWNER_COMMISSION_BILLING_TO_BE_ESTABLISHED]:
    intl.formatMessage({
      id: 'ui.getPdfLabelsByTypes.serviceOwnerCommissionBillingToBeEstablished',
      defaultMessage: 'Facture de commission à établir',
    }),
  [PdfTypeEnum.SERVICE_OWNER_COMMISSION_BILLING_TO_BE_ESTABLISHED_CANCELED]:
    intl.formatMessage({
      id: 'ui.getPdfLabelsByTypes.serviceOwnerCommissionBillingToBeEstablishedCanceled',
      defaultMessage: 'Facture de commission à établir annulée',
    }),
  [PdfTypeEnum.SERVICE_OWNER_COMMISSION_BILLING_BEFORE_30_DAYS]:
    intl.formatMessage({
      id: 'ui.getPdfLabelsByTypes.serviceOwnerCommissionBillingBefore30Days',
      defaultMessage: 'Facture de commission J-30',
    }),
  [PdfTypeEnum.SERVICE_OWNER_COMMISSION_BILLING_POST_BOOKING]:
    intl.formatMessage({
      id: 'ui.getPdfLabelsByTypes.serviceOwnerCommissionBillingPostBooking',
      defaultMessage: 'Facture de commission après séjour',
    }),
})

export const getPdfLabelsByTypes = ({
  pdfTypes,
  intl,
}: {
  pdfTypes: PdfTypeEnum[]
  intl: IntlShape
}) => {
  return pdfTypes.map((pdfType) => labels(intl)[pdfType])
}

export const getPdfLabelByType = ({
  pdfType,
  intl,
}: {
  pdfType: PdfTypeEnum
  intl: IntlShape
}) => {
  return labels(intl)[pdfType]
}
